import "../css/subpage.less";
import React from "react";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "../config";
import PageMeta from "../common/PageMeta";
import SubpageTitle from "../common/SubpageTitle";
import FaqStickyLink from "../common/FaqStickyLink";
import EnergyAiBot from "../common/EnergyAiBot";
import { PAGE_META } from "../seo/pageMeta";

const ScientificCareer: React.FC = () => {
  const { t } = useTranslation();

  const ieeePapers = [
    {
      title: t("research_page.paper1_title"),
      href: "https://doi.org/10.1109/ACCESS.2021.3136239",
    },
    {
      title: t("research_page.paper2_title"),
      href: "https://doi.org/10.1109/ACCESS.2020.2989029",
    },
  ];

  return (
    <div className="subpage subpage--scientific-career">
      <PageMeta path="/scientific_career" {...PAGE_META["/scientific_career"]} />
      <SubpageTitle titleJa="研究事業" titleEn="Research" as="h1" />

      <FaqStickyLink />
      <section
        className="subpage-section scientific-career scientific-career--dark"
        aria-label="研究事業の概要"
      >
        <div className="scientific-career__inner">
          <header className="scientific-career__hero">
            <h2 className="scientific-career__hero-title">
              <span
                className="scientific-career__hero-bar"
                aria-hidden
              />
              <span className="scientific-career__hero-title-text">
                {t("research_page.hero_title")}
              </span>
            </h2>
            <p className="scientific-career__lead">
              {t("research_page.hero_lead")}
            </p>
          </header>

          <div className="scientific-career__wrapper">
            <h3 className="scientific-career__subhead">
              {t("research_page.ai_subhead")}
            </h3>
            <div className="scientific-career__row">
              <div className="scientific-career__col scientific-career__col--text">
                <p className="scientific-career__body">
                  {t("research_page.ai_body")}
                </p>
              </div>
              <div className="scientific-career__col scientific-career__col--media">
                <img
                  src={getImageUrl("/image/img_sc_ai.png")}
                  alt="WeAI Logo"
                />
              </div>
            </div>
          </div>

          <div className="scientific-career__publications">
            <p className="scientific-career__publications-banner">
              {t("research_page.ieee_banner")}
            </p>
            <ul className="scientific-career__paper-list">
              {ieeePapers.map((paper) => (
                <li key={paper.href}>
                  <span className="scientific-career__paper-title">
                    {paper.title}
                  </span>
                  <a
                    href={paper.href}
                    className="scientific-career__paper-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {paper.href}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="scientific-career__row--joint">
            <h3 className="scientific-career__subhead scientific-career__subhead--ruled">
              {t("research_page.joint_subhead")}
            </h3>
            <div className="scientific-career__row scientific-career__row--joint">
              <div className="scientific-career__col scientific-career__col--text">
                <p className="scientific-career__body">
                  {t("research_page.joint_body")}
                </p>
              </div>
              <div className="scientific-career__col scientific-career__col--media">
                <img
                  src={getImageUrl("/image/img_sc_case.png")}
                  alt="Offshore Wind Power Turbines"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <EnergyAiBot />
    </div>
  );
};

export default ScientificCareer;
